import actions from 'actions/formInstances'
import { createFormViewContainer } from 'factories/FormView'
import userActions from 'actions/users'
import formTemplateActions from 'actions/formTemplates'
import { createFormInstanceAttachmentsDispatchToProps } from 'helpers/formInstances'
import Component from 'components/Assets/Forms/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    updateStatus: (formInstanceId, name, value) =>
      dispatch(actions.updateStatus(formInstanceId, name, value)),
    submitItem: (formInstanceId) => dispatch(actions.submitItem(formInstanceId)),
    getUsers: (params) => dispatch(userActions.getItems(params)),
    getFormTemplate: (formTemplateId) => dispatch(formTemplateActions.getItem(formTemplateId)),
    ...createFormInstanceAttachmentsDispatchToProps(dispatch, props),
  }),
})(Component)
